// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".industries-ratios {\n  background-color: white;\n}\n.industries-ratios__content {\n  padding: 0 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
